export default __webpack_public_path__ + "static/media/colors.ec32a2ed.jpg";